<template>
  <div class="search-container navbar-brand">
    <form>
      <input
        type="search"
        id="search-input"
        placeholder="Search..."
        @input="search"
      />
    </form>
    <div class="search-results card" id="search-results">
      <ul class="content list-unstyled team-members">
        <li
          v-for="result in resultSearch"
          :key="result.user.user_id"
          class="search-item"
        >
          <div class="row">
            <div class="col-xs-3">
              <div class="avatar">
                <img
                  src="img/Friends/guy-2.jpg"
                  alt="Circle Image"
                  class="img-circle img-no-padding img-responsive"
                />
              </div>
            </div>
            <div class="col-xs-5 nickname">{{ result.user.given_name }}</div>

            <div class="col-xs-3 text-right add-friend">
              <button
                class="btn btn-sm btn-azure btn-icon"
                @click="friendRequest(result.user.user_id)"
                :disabled="
                  result.relationType || disabledButtons[result.user.user_id]
                "
              >
                <i class="fa fa-user-plus"> Add Friend</i>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import { useStore } from "vuex";
import { onMounted, ref, watch } from "vue";
export default {
  setup() {
    const store = useStore();
    const searchTerm = ref("");
    const resultSearch = ref([]);
    const disabledButtons = ref({});
    const activeSearchTerm = ref("");
    onMounted(() => {
      const searchInput = document.getElementById("search-input");
      searchInput.addEventListener("focus", () => {
        document.getElementById("search-results").style.display = "block";
        searchInput.style.borderBottomLeftRadius = "0";
        searchInput.style.borderBottomRightRadius = "0";
        document.addEventListener("click", handleClickOutside);

        function handleClickOutside(event) {
          const searchInput = document.getElementById("search-input");
          const searchResults = document.getElementById("search-results");
          if (
            !searchInput.contains(event.target) &&
            !searchResults.contains(event.target)
          ) {
            searchResults.style.display = "none";
          }
        }
      });
    });

    function friendRequest(userId) {
      disabledButtons.value[userId] = true;
      store.dispatch("friend/sendFriendRequest", { userId });
    }

    function search(event) {
      searchTerm.value = event.target.value;
    }

    watch(searchTerm, (val) => {
      setTimeout(() => {
        if (val === searchTerm.value) {
          activeSearchTerm.value = val;
          searchfriend();
        }
      }, 300);
    });
    async function searchfriend() {
      if (activeSearchTerm.value) {
        const result = await store.dispatch("search/searchfriend", {
          searchTerm: activeSearchTerm.value,
        });

        if (result.length > 0) {
          resultSearch.value = result;
        }
      }
    }

    return {
      search,
      searchTerm,
      resultSearch,
      friendRequest,
      disabledButtons,
    };
  },
};
</script>

<style scoped>
.search-container {
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.search-container.navbar-brand {
  margin-left: 15px;
  padding: 10px 0px !important;
}

#search-input {
  width: 100%;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-radius: 15px !important;
  border-right: none;
  border-left: none;
  font-size: 16px;
  padding: 2px;
}

.search-results {
  position: absolute;
  width: 100%;
  background-color: white;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  display: none;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

@media (max-width: 768px) {
  .search-container.navbar-brand {
    margin-left: 0;
    padding: 10px 0px !important;
  }

  #search-input {
    font-size: 14px;
    padding: 2px;
  }

  .search-results {
    max-height: 150px;
  }
}

@media (max-width: 480px) {
  #search-input {
    font-size: 12px;
    padding: 2px;
  }

  .search-results {
    max-height: 100px;
  }
}

input:focus {
  outline: none;
}

.search-results .nickname {
  padding: 15px 0px;
}

.search-results .add-friend {
  padding: 10px 15px 0px;
}

/* Hide scrollbar for WebKit browsers (Chrome, Safari) */
.search-results::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for Firefox */
.search-results {
  scrollbar-width: none;
  /* Firefox */
}

.search-item {
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background-color: #f0f0f0;
}
</style>